import React from 'react'

export const OurAchievements = () => {
  return (
    <div className='achievementContainer'>
        <div className='container'>
            <div className='achieveTitle'>Our Achievements</div>
            <div className='achieveDesc'>Our story is one of continuous growth and evolution. We started as a small team with big dreams, determined to create a real estate platform that transcended the ordinary.</div>
            <div className='achievementGrid'>
                <div className='achieveCard'>
                    <div>5+ Years of Excellence</div>
                    <div>With over 5 years in the industry, we've amassed a wealth of knowledge and experience.</div>

                </div>
                    <div className='achieveCard'>
                    <div>Happy Clients</div>
                    <div>Our greatest achievement is the satisfaction of our clients. Their success stories fuel our passion for what we do.</div>

                </div>
                    <div className='achieveCard'>
                    <div>Industry Recognition</div>
                    <div>We've earned the respect of our peers and industry leaders, with accolades and awards that reflect our commitment to excellence.</div>

                </div>

            </div>

        </div>

    </div>
  )
}
